<template>
    <tailwind-layout title="Asset Verification">
        <template #header>
            <boost-header
                title="Asset Verification"
                subtitle="Please add your financial institution(s)"
                :report-id="report.id"
            >
                <button v-if="!asset_report" type="button" class="whiteButton" data-test="add-account" @click="start">
                    Add New Bank Account
                </button>
                <a
                    v-else
                    :href="route('user-assets.view-report', asset_report.asset_report_token)"
                    target="_blank"
                    class="whiteButton"
                    data-test="view"
                >
                    View Asset Report
                </a>
            </boost-header>
        </template>

        <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
            <div class="shadow overflow-hidden lg:border">
                <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-blue-50">
                        <tr>
                            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">Account Last 4 Digits</th>
                            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">Bank Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="account in accounts" :key="account.id" class="bg-gray-50 border-b">
                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">{{ account.account_last_4 }}</td>
                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">{{ account.bank_name }}</td>
                        </tr>
                        <tr v-if="!accounts.length">
                            <td colspan="2" class="px-6 py-4 whitespace-nowrap text-dark-gray-400 text-sm font-medium text-center">
                                No bank accounts were found.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <alert-card v-if="!asset_report" :type="'warning'" class="mt-4">
            Once you've finished adding your financial institutions, click
            <button type="button" class="text-blue-600 underline" data-test="create-report" @click="createReport">Create Assets Report</button>.
        </alert-card>
        <full-page-loader v-if="isLoader" />
    </tailwind-layout>
</template>

<script>
import axios from 'axios'
import { router } from '@inertiajs/vue3'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FullPageLoader from '@/Shared/FullPageLoader.vue'
import AlertCard from '@/Shared/AlertCard.vue'
import BoostHeader from './BoostHeader.vue'
import { openPlaidLink } from './plaidLink'

/**
 * 86bc8uyd2: the Applicant Boost's assets step. A copy of Users/Assets.vue
 * whose asset report is created against the report.
 */
export default {
    components: {
        TailwindLayout,
        FullPageLoader,
        AlertCard,
        BoostHeader,
    },
    props: {
        report: {
            type: Object,
            required: true,
        },
        accounts: {
            type: Array,
            default: () => [],
        },
        asset_report: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoader: false,
        }
    },
    methods: {
        async start() {
            this.isLoader = true
            try {
                const response = await axios.post(route('user-assets.create-link-token'), {
                    product: 'auth',
                })
                this.isLoader = false
                if (response.data.status) {
                    openPlaidLink(response.data.public_token, {
                        onSuccess: (publicToken, metadata) => this.finish(publicToken, metadata),
                    })
                }
            } catch (error) {
                this.isLoader = false
                console.error('Error:', error.response ? error.response.data : error.message)
            }
        },
        async finish(publicToken, metadata) {
            this.isLoader = true
            try {
                await axios.post(route('user-assets.exchange-token-and-retrieve-account'), {
                    public_token: publicToken,
                    metadata,
                })
            } catch (error) {
                console.error('Error:', error.response ? error.response.data : error.message)
            } finally {
                this.isLoader = false
                router.reload()
            }
        },
        createReport() {
            this.isLoader = true
            router.post(route('reports.boost.assets.create-report', this.report.id), {}, {
                onFinish: () => {
                    this.isLoader = false
                },
            })
        },
    },
}
</script>
